import { createAction, createAsyncAction } from 'typesafe-actions';

import type { FeatureFlag, FeatureFlagCreateData } from '@portal/api-models';

import type { IsomorphicRequestPayload } from '../types';

import { FeatureFlagActionType } from './actionTypes';
import type {
  DeleteFeatureFlagRequestPayload,
  DeleteFeatureFlagResponse,
  DisableFeatureFlagRequestPayload,
  EnableFeatureFlagRequestPayload,
  GetFeatureFlagByUuidRequestPayload,
  UpdateFeatureFlagRequestPayload,
} from './types';

export const getAllFeatureFlagsAction = createAsyncAction(
  FeatureFlagActionType.GET_ALL_FEATURE_FLAGS_REQUEST,
  FeatureFlagActionType.GET_ALL_FEATURE_FLAGS_SUCCESS,
  FeatureFlagActionType.GET_ALL_FEATURE_FLAGS_FAILURE
)<IsomorphicRequestPayload, FeatureFlag[], Error>();

export const getFeatureFlagByUuidAction = createAsyncAction(
  FeatureFlagActionType.GET_FEATURE_FLAG_BY_UUID_REQUEST,
  FeatureFlagActionType.GET_FEATURE_FLAG_BY_UUID_SUCCESS,
  FeatureFlagActionType.GET_FEATURE_FLAG_BY_UUID_FAILURE
)<GetFeatureFlagByUuidRequestPayload, FeatureFlag, Error>();

export const createFeatureFlagAction = createAsyncAction(
  FeatureFlagActionType.CREATE_FEATURE_FLAG_REQUEST,
  FeatureFlagActionType.CREATE_FEATURE_FLAG_SUCCESS,
  FeatureFlagActionType.CREATE_FEATURE_FLAG_FAILURE
)<FeatureFlagCreateData & IsomorphicRequestPayload, FeatureFlag, Error>();

export const updateFeatureFlagAction = createAsyncAction(
  FeatureFlagActionType.UPDATE_FEATURE_FLAG_REQUEST,
  FeatureFlagActionType.UPDATE_FEATURE_FLAG_SUCCESS,
  FeatureFlagActionType.UPDATE_FEATURE_FLAG_FAILURE
)<UpdateFeatureFlagRequestPayload, FeatureFlag, Error>();

export const enableFeatureFlagAction = createAsyncAction(
  FeatureFlagActionType.ENABLE_FEATURE_FLAG_REQUEST,
  FeatureFlagActionType.ENABLE_FEATURE_FLAG_SUCCESS,
  FeatureFlagActionType.ENABLE_FEATURE_FLAG_FAILURE
)<EnableFeatureFlagRequestPayload, FeatureFlag, Error>();

export const disableFeatureFlagAction = createAsyncAction(
  FeatureFlagActionType.DISABLE_FEATURE_FLAG_REQUEST,
  FeatureFlagActionType.DISABLE_FEATURE_FLAG_SUCCESS,
  FeatureFlagActionType.DISABLE_FEATURE_FLAG_FAILURE
)<DisableFeatureFlagRequestPayload, FeatureFlag, Error>();

export const deleteFeatureFlagAction = createAsyncAction(
  FeatureFlagActionType.DELETE_FEATURE_FLAG_REQUEST,
  FeatureFlagActionType.DELETE_FEATURE_FLAG_SUCCESS,
  FeatureFlagActionType.DELETE_FEATURE_FLAG_FAILURE
)<DeleteFeatureFlagRequestPayload, DeleteFeatureFlagResponse, Error>();

export const toggleCreate = createAction(
  FeatureFlagActionType.TOGGLE_CREATE
)<undefined>();
